import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 px-6 text-center">
      {/* Animated 404 Illustration */}
      <div className="max-w-md">
        <svg
          className="w-full"
          viewBox="0 0 700 300"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            dy=".35em"
            fontSize="100"
            fontWeight="bold"
            fill="#6B7280">
            404
          </text>
        </svg>
      </div>

      {/* Heading and Description */}
      <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mt-6 ">
        Oops! Page Not Found
      </h1>
      <p className="text-gray-600 mt-2">
        The page you’re looking for doesn’t exist or has been moved.
      </p>

      {/* Back to Home Button */}
      <Link
        to="/"
        className="mt-6 px-6 py-3 text-white bg-blue-600 hover:bg-blue-700 transition rounded-lg shadow-md text-lg font-medium">
        Explore
      </Link>
    </div>
  );
};

export default NotFound;
